import { render, staticRenderFns } from "./batch-upload.vue?vue&type=template&id=15095abd"
import script from "./batch-upload.vue?vue&type=script&lang=js"
export * from "./batch-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports